import {combineReducers} from "redux";

import elliCustomerService from "@atg-content-shared/elli-customer-service/src/domain/slice";
import {memberReducer} from "@atg-global-shared/member-data-access";
import {
    modalsReducer as modals,
    modalDataReducer as modalData,
} from "@atg-shared/modals-data-access";
import {createHorseReducer} from "@atg-horse/horse-app";
import {limitsReducer as limits} from "@atg-responsible-gambling-shared/limits-domain";
import {userGamblingSummary} from "@atg-responsible-gambling-shared/user-gambling-summary-domain";
import {activeBreakpoint} from "atg-match-media/domain/matchMediaReducer";

const createRootReducer = (asyncReducers: any = {}) =>
    combineReducers<any, any>({
        // reducers that are lazily injected later will end up here
        ...asyncReducers.root,
        activeBreakpoint, // TODO: deprecated, should be removed after refactoring to `atg-breakpoints`
        auth: () => window._frameStore.getState().auth,
        accessToken: () => window._frameStore.getState().accessToken,
        kycQuestionnaire: () => window._frameStore.getState().kycQuestionnaire,
        limits,
        login: () => window._frameStore.getState().login,
        loginHAAPI: () => window._frameStore.getState().loginHAAPI,
        mainMenu: () => window._frameStore.getState().mainMenu,
        mainNavbar: () => window._frameStore.getState().mainNavbar,
        member: memberReducer,
        modals,
        modalData,
        userGamblingSummary,
        router: () => window._frameStore.getState().router,
        user: () => window._frameStore.getState().user,
        verticals: () => window._frameStore.getState().verticals,
        horse: createHorseReducer(asyncReducers.horse),
        elliCustomerService,
    });

export default createRootReducer;
